export const navigations = [
  { name: 'Synopsis Report', path: '/dashboard/default', icon: 'apps' },


    
 
 
      /*{ name: 'Stock Branch', icon: 'format_italic', path: '/courier/stock-branch' },*/
      { name: 'Create', icon: 'add_circle', path: '/courier/new-pickup' },
	    { name: 'CN Generate', icon: 'public', path: '/courier/new-booking' },
      { name: 'Tracking History', icon: 'search', path: '/courier/search-update-pickup' },
      { name: 'Fast Update', icon: 'flag', path: '/courier/quick-update-pickup' },
      { name: 'Scan POD', icon: 'attach_file', path: '/courier/pod-upload' }, 
 


 /* {
    name: 'Test',
    icon: 'assistant',
    children: [
      { name: 'Test', icon: 'format_italic', path: '/material/test' },
    ], { name: 'test', icon: 'format_italic', path: '/report/test' },
  },
 
*/
  {
    name: 'Billing',
    icon: 'attach_money', 
    path: '/billing',
  }, 


  {
    name: 'Support',
    icon: 'brush',
    path: '/issue',
  },

  {
    name: 'Reports',
    icon: 'trending_up',
    children: [
      { name: 'Collection Report', icon: 'format_italic', path: '/report/pickup' },
      { name: 'Transit Report', icon: 'format_italic', path: '/report/shipment' },
      { name: 'DataEntry Report', icon: 'pie_chart', path: '/report/data_entry' },
	   { name: 'Riders', icon: 'pie_chart', path: '/report/delivery_boy' },
    ],
  },





 

  {
    name: 'System Setup',
    icon: 'launch',
    type: 'extLink',
    path: process.env.REACT_APP_BACKOFFICE_URL,
  },


  /*{ label: 'PAGES', type: 'label' },

  {
    name: 'Session/Auth',
    icon: 'security',
    children: [
      { name: 'Sign in', iconText: 'SI', path: '/session/signin' },
      { name: 'Sign up', iconText: 'SU', path: '/session/signup' },
      { name: 'Forgot Password', iconText: 'FP', path: '/session/forgot-password' },
      { name: 'Error', iconText: '404', path: '/session/404' },
    ],
  },
  
  {
    name: 'Components',
    icon: 'favorite',
    badge: { value: '30+', color: 'secondary' },
    children: [
      { name: 'Auto Complete', path: '/material/autocomplete', iconText: 'A' },
      { name: 'Buttons', path: '/material/buttons', iconText: 'B' },
      { name: 'Checkbox', path: '/material/checkbox', iconText: 'C' },
      { name: 'Dialog', path: '/material/dialog', iconText: 'D' },
      { name: 'Expansion Panel', path: '/material/expansion-panel', iconText: 'E' },
      { name: 'Form', path: '/material/form', iconText: 'F' },
      { name: 'Icons', path: '/material/icons', iconText: 'I' },
      { name: 'Menu', path: '/material/menu', iconText: 'M' },
      { name: 'Progress', path: '/material/progress', iconText: 'P' },
      { name: 'Radio', path: '/material/radio', iconText: 'R' },
      { name: 'Switch', path: '/material/switch', iconText: 'S' },
      { name: 'Slider', path: '/material/slider', iconText: 'S' },
      { name: 'Snackbar', path: '/material/snackbar', iconText: 'S' },
      { name: 'Table', path: '/material/table', iconText: 'T' },
    ],
  },

  {
    name: 'Charts',
    icon: 'trending_up',
    children: [{ name: 'Echarts', path: '/charts/echarts', iconText: 'E' }],
  },*/

];
